import Button from '@/components/ui/button/button.component';
import { cn } from '@/lib/utils';
import { IntlShape, useIntl } from 'react-intl';
import { AppVersion } from '../app-version/app-version.component';
import { footerTranslations } from './footer.messages';

const footerConfig = (t: IntlShape) => [
  {
    id: 1,
    title: t.formatMessage(footerTranslations.cookieNotice),
    link: 'https://www.siemens.com/cookie-notice',
  },
  {
    id: 2,
    title: t.formatMessage(footerTranslations.privacyNotice),
    link: 'https://www.siemens.com/privacy-notice',
  },
  {
    id: 3,
    title: t.formatMessage(footerTranslations.termsOfUse),
    link: 'https://www.siemens.com/terms-of-use',
  },
  {
    id: 4,
    title: t.formatMessage(footerTranslations.digitalId),
    link: 'https://www.siemens.com/digital-id',
  },
  {
    id: 5,
    title: t.formatMessage(footerTranslations.corporateInformation),
    link: 'https://www.siemens.com/corporate-information',
  },
];

export const Footer = () => {
  const t = useIntl();

  const onLinkClick = (link: string) => {
    window.open(link, '_blank');
  };

  return (
    <div
      className={cn(
        'fixed bottom-0 left-0 right-0 z-10',
        'bg-white h-10 px-18',
        'flex flex-row justify-between items-center',
        'border-t border-other-stroke',
      )}
    >
      <div data-testid="footer-link-container" className="flex flex-row justify-between items-center gap-4">
        {footerConfig(t).map((item, index) => (
          <div className="flex flex-row justify-between items-center gap-4" key={item.id}>
            <Button
              variant="ghost"
              data-testid="footer-link"
              onClick={() => onLinkClick(item.link)}
              className="typo-secondary text-secondary-text"
            >
              {item.title}
            </Button>
            {index < footerConfig(t).length - 1 && <div className="block bg-secondary-text rounded-full w-1 h-1" />}
          </div>
        ))}
      </div>
      <div className="flex flex-row justify-between items-center gap-4">
        <p data-testid="footer-copyright-text" className="typo-secondary text-secondary-text">
          {t.formatMessage(footerTranslations.siemens, {
            year: new Date().getFullYear(),
          })}
        </p>
        <AppVersion />
      </div>
    </div>
  );
};
